/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./subtask.vue?vue&type=template&id=561d39d3&scoped=true"
import script from "./subtask.vue?vue&type=script&lang=js"
export * from "./subtask.vue?vue&type=script&lang=js"
import style0 from "./subtask.vue?vue&type=style&index=0&id=561d39d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d39d3",
  null
  
)

export default component.exports